<template>
    <div class="nav-content-data">
        <div class="nav-content-data__list">
            <section class="data-list__section">
                <!-- CTA: -->
                <!-- hidden for media item since it can only select: -->
                <div v-if="itemType === 'content' && !isContentSelect">
                    <button v-if="!data.isFolder && !data.readOnly" class="nav-content-data__cta-button nav-content-data__cta-button--add-edit" @click.stop="$emit('edit')">
                        Edit
                    </button>

                    <button v-if="data.addChildrenAllowed" class="nav-content-data__cta-button nav-content-data__cta-button--add-edit" @click.stop="$emit('add')">
                        Add Child Page
                    </button>

                    <button v-if="data.addChildrenAllowed" class="nav-content-data__cta-button nav-content-data__cta-button--add-edit" @click.stop="$emit('addfolder')">
                        Add Child Folder
                    </button>

                    <button v-if="!data.readOnly" class="nav-content-data__cta-button nav-content-data__cta-button--delete" @click.stop="onDelete">
                        <span v-if="!isDeleting">Delete</span>

                        <font-awesome-icon
                            v-else
                            class="toolbar__vert-icon"
                            :icon="['fas', 'spinner']"
                            :spin="true"
                        />
                    </button>
                </div>

                <h2 class="data-list__item-name">{{ data.name }}</h2>
                <data-list-item title="Path" :value="data.path" />
                <data-list-item title="ID" :value="data.id" />

                <!-- build manually to add link -->
                <div v-if="!data.isFolder" class="data-list__item">
                    <div class="data-list__item-title">URL</div>
                    <div class="data-list__item-value">
                        <a :href="data.url" target="_blank" rel="noreferrer noopener">{{ data.url }}</a>
                    </div>
                </div>
            </section>

            <section v-if="!data.isFolder" class="data-list__section">
                <h2 class="data-list__section-title">Content</h2>
                <data-list-item title="Article Summary" :value="data.articleSummary" />
                <data-list-item title="Main Title" :value="data.mainTitle" />
            </section>

            <section v-if="!data.isFolder" class="data-list__section">
                <h2 class="data-list__section-title">Metadata</h2>
                <data-list-item title="Template Name" :value="data.templateName" />
                <!-- <data-list-item title="Template ID" :value="data.templateId" /> -->
                <data-list-item title="Browser Title" :value="data.browserTitle" />
                <data-list-item title="Meta Description" :value="data.metaDescription" />
                <data-list-item title="Meta Keywords" :value="data.metaKeywords" />
                <data-list-checkbox :checkbox-value="data.isPrototype">
                    This page is a prototype to be used by other pages
                </data-list-checkbox>
                <data-list-checkbox :checkbox-value="data.noIndex">
                    NoIndex - NOINDEX tag tells crawlers not to index a specific page
                </data-list-checkbox>
                <data-list-checkbox :checkbox-value="data.noFollow">
                    NoFollow - NOFOLLOW tag tells crawlers not to follow the links on a specific page
                </data-list-checkbox>
                <data-list-checkbox :checkbox-value="data.noArchive">
                    NoArchive - NOFOLLOW tag tells crawlers not to store a cached copy of your page
                </data-list-checkbox>
                <data-list-checkbox :checkbox-value="data.noArchive">
                    NoSnippet - NOFOLLOW tag tells crawlers not to show a snippet (description) under your listing,
                    it will also not show a cached link in the search results
                </data-list-checkbox>
            </section>
        </div>
        <div v-if="isContentSelect" class="nav-content-data__buttons">
            <button
                class="nav-content-data__button nav-content-data__button--select"
                @click="select"
            >
                SELECT
            </button>
        </div>
    </div>
</template>

<script>
import DataListItem from '@/components/page-editor/navigation-tree/data-list-item';
import DataListCheckbox from '@/components/page-editor/navigation-tree/data-list-checkbox';
import listenOnRootMixin from '@/mixins/listen-on-root';

export default {
    name: 'content-data',

    components: {
        DataListItem,
        DataListCheckbox,
    },

    mixins: [listenOnRootMixin],

    props: {
        data: {
            type: Object,
            required: true,
        },

        itemType: {
            type: String,
            default: 'content',
        },

        isContentSelect: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isDeleting: false,
        };
    },

    created() {
        this.listenOnRoot('flex::delete-content::complete', () => this.isDeleting = false);
    },

    methods: {
        select() {
            this.$emit('select-content', this.data);
        },

        onDelete() {
            this.$emit('delete');
            this.isDeleting = true;
        },
    },
};
</script>

<style lang="scss">
.nav-content-data {
    $this: &;

    padding: 15px;

    &__cta-button {
        z-index: 2; // issue with z-index for toggles going over button
        padding: 7px 20px;
        margin: 4px 0 18px;
        border-radius: 4px;
        color: white;
        font-size: 13px;

        #{$this}__cta-button + & {
            margin-left: 16px;
        }

        &--add-edit {
            color: var(--form-buttonColor);
            background-color: var(--form-buttonBackgroundColor);

            &:hover {
                color: var(--form-buttonHoverColor);
                background-color: var(--form-buttonHoverBackgroundColor);
            }
        }

        &--delete {
            color: var(--form-altButtonColor);
            background-color: var(--form-altButtonBackgroundColor);

            &:hover {
                color: var(--form-altButtonHoverColor);
                background-color: var(--form-altButtonHoverBackgroundColor);
            }
        }
    }

    &__buttons {
        display: flex;
        padding: 0;
        margin: 0;
    }

    &__button {
        flex-grow: 1;
        min-height: 50px;
        z-index: 2; // issue with z-index for toggles going over button

        &--select {
            color: var(--form-buttonColor);
            background-color: var(--form-buttonBackgroundColor);

            &:hover {
                color: var(--form-buttonHoverColor);
                background-color: var(--form-buttonHoverBackgroundColor);
            }
        }

        &--cancel {
            color: var(--form-altButtonColor);
            background-color: var(--form-altButtonBackgroundColor);

            &:hover {
                color: var(--form-altButtonHoverColor);
                background-color: var(--form-altButtonHoverBackgroundColor);
            }
        }
    }
}
</style>
